<div class="formula-builder">
  <h3>Formula Builder</h3>

  <!-- Loading State -->
  @if (!builder_ready) {
    <div class="row center">
      @if (!parentComponent || !second_object) {
        <div>
          Waiting for component selection...
        </div>
      }
      @if (parentComponent && second_object) {
        <div>
          Loading properties...
        </div>
      }
    </div>
  }

  <!-- Builder Content -->
  @if (builder_ready) {
    <div class="formula-builder-content">
      <div class="property-sections-container">
        <!-- Parent Component Properties -->
        <div class="property-section">
          <h4>{{parentComponent?.attributes?.name}} Properties</h4>
          <div class="row min-height">
            <mat-form-field class="property-select no-label">
              <mat-select [(ngModel)]="selected_parent_property" placeholder="Select property">
                @for (prop of parent_properties; track prop) {
                  <mat-option [value]="prop">
                    {{prop.attributes.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button type="button" mat-icon-button (click)="addParentProperty($event)"
              [disabled]="!selected_parent_property">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
        <!-- Second Object Properties -->
        <div class="property-section">
          <h4>{{second_object?.attributes?.name}} Properties</h4>
          <div class="row min-height">
            <mat-form-field class="property-select no-label">
              <mat-select [(ngModel)]="selected_second_property" placeholder="Select property">
                @for (prop of second_object_properties; track prop) {
                  <mat-option [value]="prop">
                    {{prop.attributes.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button type="button" mat-icon-button (click)="addSecondProperty($event)"
              [disabled]="!selected_second_property">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
        <!-- Parent Name Properties -->
        <div class="property-section">
          <h4>Parent Component Name Properties</h4>
          <div class="row center min-height">
            <mat-form-field class="property-select no-label">
              <mat-select [(ngModel)]="selected_parent_name_prop" placeholder="Select name property">
                @for (prop of componentNameProperties; track prop) {
                  <mat-option [value]="prop.id">
                    {{prop.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button type="button" mat-icon-button (click)="addParentNameProperty($event)"
              [disabled]="!selected_parent_name_prop">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
        <!-- Object Name Properties -->
        <div class="property-section">
          <h4>Second Object Name Properties</h4>
          <div class="row min-height">
            @if (relationship_type==='component') {
              <mat-form-field class="property-select no-label">
                <mat-select [(ngModel)]="selected_object_name_prop" placeholder="Select name property">
                  @for (prop of componentNameProperties; track prop) {
                    <mat-option [value]="prop.id">
                      {{prop.label}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (relationship_type==='event') {
              <mat-form-field class="property-select no-label">
                <mat-select [(ngModel)]="selected_object_name_prop" placeholder="Select name property">
                  @for (prop of eventNameProperties; track prop) {
                    <mat-option [value]="prop.id">
                      {{prop.label}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <button type="button" mat-icon-button (click)="addObjectNameProperty($event)"
              [disabled]="!selected_object_name_prop">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <!-- Formula Text Area -->
      <div class="formula-section">
        <mat-form-field class="formula-field" appearance="fill">
          <mat-label>Formula</mat-label>
          <textarea
            matInput
            [(ngModel)]="formula"
            (input)="onFormulaInput($event)"
            placeholder="Build your formula here..."
            rows="3">
          </textarea>
        </mat-form-field>
      </div>
    </div>
  }
</div>
